import CloudUpload from '@mui/icons-material/CloudUpload'
import { lighten } from '@mui/material'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import Typography from '@mui/material/Typography'
import type { ReactNode } from 'react'

type Props = {
  label: string
  children: ReactNode
  disabled?: boolean
  image?: ReactNode
}

export const PreUploadContent = ({ label, children, disabled, image }: Props) => {
  return (
    <Box display="grid">
      <Typography
        variant="h5"
        align="center"
        sx={{ color: (theme) => (disabled ? theme.palette.primary.light : theme.palette.primary.dark) }}
      >
        {label}
      </Typography>
      <Box
        display="grid"
        gridTemplateColumns="1fr auto 1fr"
        columnGap={8}
      >
        <Box
          display="grid"
          justifyContent="end"
        >
          <Collapse
            in={!!image}
            mountOnEnter
            unmountOnExit
          >
            {image}
          </Collapse>
          <Collapse
            in={!image}
            mountOnEnter
            unmountOnExit
          >
            <Box>
              <CloudUpload
                sx={{
                  fontSize: '6rem',
                  color: (theme) => lighten(disabled ? theme.palette.primary.light : theme.palette.primary.dark, 0.25),
                }}
              />
            </Box>
          </Collapse>
        </Box>
        <Box
          display="grid"
          alignItems="center"
          alignContent="center"
          justifyContent="center"
          rowGap={0.5}
        >
          {children}
        </Box>
        <Box />
      </Box>
    </Box>
  )
}
